<template>
  <div class="history-empty-wrap">
    <img
      :src="acknowledgementsPlaceholderSvg"
      width="342"
      height="376"
      alt=""
      class="history-empty-img"
    >
    <div class="history-empty-overlay">
      <span class="history-empty-box">
        <NoAcknowledgementsBox />
      </span>
      <div class="history-empty-text text-body-1 text-textDark">
        No previous acknowledgements
      </div>
    </div>
  </div>
</template>

<script setup>
import acknowledgementsPlaceholderSvg from '@/assets/acknowledgements-placeholder.svg';
import NoAcknowledgementsBox from '@/assets/no-acknowledgements-box.svg?component';
</script>

<style scoped lang="less">
.history-empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 200px;
  margin-left: -24px;
  margin-right: -24px;
}

.history-empty-img {
  display: block;
  max-width: 100%;
  height: auto;
}

.history-empty-overlay {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.history-empty-box {
  display: inline-block;
  color: @grey-500;
  line-height: 0;
}

.history-empty-box :deep(svg) {
  display: block;
  width: 60px;
  height: 60px;
}

.history-empty-text {
  white-space: nowrap;
}
</style>
